import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { GetItemsParams, ReportListData } from './appointments.model';

@Injectable({
  providedIn: 'root'
})
export class AppoinmentsService {
  constructor(private apiService: HttpService) {}

  getAppoinmentReport(param: GetItemsParams, reportName: string): Observable<ReportListData> {
    let params = this.apiService.Params;
    params = params.set('searchValue', param.searchValue);
    params = params.set('sortColumn', param.sortColumn);
    params = params.set('sortOrder', param.sortOrder);
    params = params.set('clinicId', param.clinicId ? param.clinicId : 0);
    params = params.set('fromDate', param.fromDate);
    params = params.set('toDate', param.toDate);
    return this.apiService.getData<any>(`AppointmentReport/${reportName}`, params);
  }

  exportAppoinmentReport(param: GetItemsParams, reportName: string): Observable<any> {
    let params = this.apiService.Params;
    params = params.set('searchValue', param.searchValue ?? '');
    params = params.set('clinicId', param.clinicId ? param.clinicId : 0);
    params = params.set('fromDate', param.fromDate);
    params = params.set('toDate', param.toDate);
    return this.apiService.getBlobData(`AppointmentReport/${reportName}`, params);
  }
}
